import { useState } from 'react';

export function useDeviceFilters() {
    const [searchValue, setSearchValue] = useState('');
    const [selectedModels, setSelectedModels] = useState<string[]>([]);
    const [selectedManufacturers, setSelectedManufacturers] = useState<string[]>([]);
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);

    return {
        searchValue,
        selectedModels,
        selectedManufacturers,
        selectedStatuses,
        setSearchValue,
        setSelectedModels,
        setSelectedManufacturers,
        setSelectedStatuses
    };
}
